export default "__VITE_ASSET__DM2rY8Y6__"